import React from 'react';

interface IDetailPageContext {
  refreshTimedLots: () => Promise<void>;
}

export const DetailPageContext = React.createContext<Partial<IDetailPageContext>>({});

